import { BuilderState } from '@/types/builder';

export const HELP_CENTRE_LIST_NAME = 'HelpCentreList';

export interface HelpCentreListInput {
  title: string;
  builderState: BuilderState;
}
